import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal } from '../../../components/functions'
import CurrencyInput from '../../../components/CurrencyInput'

import { useEnergiaCombustivelContext } from '../../../context/energiaCombustivelContext'

import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {


    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const { energiaCombustivel_id, setEnergiaCombustivel_id } = useEnergiaCombustivelContext()



    const [combustivel, setCombustivel] = useState('')
    const [unidade, setUnidade] = useState('')
    const [identificacao, setIdentificacao] = useState('')


    const [consumoJan, setConsumoJan] = useState('')
    const [custoJan, setCustoJan] = useState('')

    const [consumoFev, setConsumoFev] = useState('')
    const [custoFev, setCustoFev] = useState('')

    const [consumoMar, setConsumoMar] = useState('')
    const [custoMar, setCustoMar] = useState('')

    const [consumoAbr, setConsumoAbr] = useState('')
    const [custoAbr, setCustoAbr] = useState('')

    const [consumoMai, setConsumoMai] = useState('')
    const [custoMai, setCustoMai] = useState('')

    const [consumoJun, setConsumoJun] = useState('')
    const [custoJun, setCustoJun] = useState('')

    const [consumoJul, setConsumoJul] = useState('')
    const [custoJul, setCustoJul] = useState('')

    const [consumoAgo, setConsumoAgo] = useState('')
    const [custoAgo, setCustoAgo] = useState('')

    const [consumoSet, setConsumoSet] = useState('')
    const [custoSet, setCustoSet] = useState('')

    const [consumoOut, setConsumoOut] = useState('')
    const [custoOut, setCustoOut] = useState('')

    const [consumoNov, setConsumoNov] = useState('')
    const [custoNov, setCustoNov] = useState('')

    const [consumoDez, setConsumoDez] = useState('')
    const [custoDez, setCustoDez] = useState('')


    const handleChange = (e) => {
        e.preventDefault();
    }


    
    async function consultaCombustiveisDetMensal() {

        if (energiaCombustivel_id) {

            await api.get(`energiaCombustivelMensalListaUm/${energiaCombustivel_id}`).then((result) => {

                //console.log(result.data)
                
                var data = result.data

                setConsumoJan(data.consumoJan == null ? '' : data.consumoJan.toString())
                setCustoJan(data.custoJan == null ? '' : data.custoJan.toString())

                setConsumoFev(data.consumoFev == null ? '' : data.consumoFev.toString())
                setCustoFev(data.custoFev == null ? '' : data.custoFev.toString())

                setConsumoMar(data.consumoMar == null ? '' : data.consumoMar.toString())
                setCustoMar(data.custoMar == null ? '' : data.custoMar.toString())

                setConsumoAbr(data.consumoAbr == null ? '' : data.consumoAbr.toString())
                setCustoAbr(data.custoAbr == null ? '' : data.custoAbr.toString())

                setConsumoMai(data.consumoMai == null ? '' : data.consumoMai.toString())
                setCustoMai(data.custoMai == null ? '' : data.custoMai.toString())

                setConsumoJun(data.consumoJun == null ? '' : data.consumoJun.toString())
                setCustoJun(data.custoJun == null ? '' : data.custoJun.toString())

                setConsumoJul(data.consumoJul == null ? '' : data.consumoJul.toString())
                setCustoJul(data.custoJul == null ? '' : data.custoJul.toString())

                setConsumoAgo(data.consumoAgo == null ? '' : data.consumoAgo.toString())
                setCustoAgo(data.custoAgo == null ? '' : data.custoAgo.toString())

                setConsumoSet(data.consumoSet == null ? '' : data.consumoSet.toString())
                setCustoSet(data.custoSet == null ? '' : data.custoSet.toString())

                setConsumoOut(data.consumoOut == null ? '' : data.consumoOut.toString())
                setCustoOut(data.custoOut == null ? '' : data.custoOut.toString())

                setConsumoNov(data.consumoNov == null ? '' : data.consumoNov.toString())
                setCustoNov(data.custoNov == null ? '' : data.custoNov.toString())

                setConsumoDez(data.consumoDez == null ? '' : data.consumoDez.toString())
                setCustoDez(data.custoDez == null ? '' : data.custoDez.toString())


            }).catch((err) => {

                console.log(err.response)

            })

        }

    }
    
    async function consultaCombustiveisDet() {

        if (energiaCombustivel_id) {


            await api.get(`energiaCombustivelListaUm/${energiaCombustivel_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data[0]

                setCombustivel(data.combustivel)
                setIdentificacao(data.identificacao)
                setUnidade(data.unidade)

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }



    function salva() {

        if (combustivel == '') {

            window.toastr.error('<b>Combustível</b> não pode ficar em branco!')
            return false

        }

        if (identificacao == '') {

            //window.toastr.error('<b>Identificação</b> não pode ficar em branco!')
            //return false
        }


        /*
        if (consumoJan != '' && custoJan == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>janeiro</b>!')
            return false

        }

        if (consumoFev != '' && custoFev == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>fevereiro</b>!')
            return false

        }

        if (consumoMar != '' && custoMar == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>março</b>!')
            return false

        }

        if (consumoAbr != '' && custoAbr == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>abril</b>!')
            return false

        }

        if (consumoMai != '' && custoMai == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>maio</b>!')
            return false

        }

        if (consumoJun != '' && custoJun == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>junho</b>!')
            return false

        }

        if (consumoJul != '' && custoJul == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>julho</b>!')
            return false

        }


        if (consumoAgo != '' && custoAgo == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>agosto</b>!')
            return false

        }

        if (consumoSet != '' && custoSet == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>setembro</b>!')
            return false

        }

        if (consumoOut != '' && custoOut == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>outubro</b>!')
            return false

        }

        if (consumoNov != '' && custoNov == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>novembro</b>!')
            return false

        }


        if (consumoDez != '' && custoDez == '') { 

            window.toastr.error('Por favor, informe o <b>custo</b> do combustível em <b>dezembro</b>!')
            return false

        }





        if (consumoJan == '' && custoJan != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>janeiro</b>!')
            return false

        }

        if (consumoFev == '' && custoFev != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>fevereiro</b>!')
            return false

        }

        if (consumoMar == '' && custoMar != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>março</b>!')
            return false

        }

        if (consumoAbr == '' && custoAbr != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>abril</b>!')
            return false

        }

        if (consumoMai == '' && custoMai != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>maio</b>!')
            return false

        }

        if (consumoJun == '' && custoJun != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>junho</b>!')
            return false

        }

        if (consumoJul == '' && custoJul != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>julho</b>!')
            return false

        }


        if (consumoAgo == '' && custoAgo != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>agosto</b>!')
            return false

        }

        if (consumoSet == '' && custoSet != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>setembro</b>!')
            return false

        }

        if (consumoOut == '' && custoOut != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>outubro</b>!')
            return false

        }

        if (consumoNov == '' && custoNov != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>novembro</b>!')
            return false

        }


        if (consumoDez == '' && custoDez != '') { 

            window.toastr.error('Por favor, informe o <b>consumo</b> do combustível em <b>dezembro</b>!')
            return false

        }

        */


        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            combustivel: combustivel,
            unidade: unidade,
            identificacao: identificacao.toUpperCase(),
            consumoJan: consumoJan,
            custoJan: custoJan,
            consumoFev: consumoFev,
            custoFev: custoFev,
            consumoMar: consumoMar,
            custoMar: custoMar,
            consumoAbr: consumoAbr,
            custoAbr: custoAbr,
            consumoMai: consumoMai,
            custoMai: custoMai,
            consumoJun: consumoJun,
            custoJun: custoJun,
            consumoJul: consumoJul,
            custoJul: custoJul,
            consumoAgo: consumoAgo,
            custoAgo: custoAgo,
            consumoSet: consumoSet,
            custoSet: custoSet,
            consumoOut: consumoOut,
            custoOut: custoOut,
            consumoNov: consumoNov,
            custoNov: custoNov,
            consumoDez: consumoDez,
            custoDez: custoDez,
        }


        console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaCombustivel_id) {

                        //console.log('put')

                        api.put(`energiaCombustivel/${energiaCombustivel_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //if (result.data.status == 'ok') {
    
                                //setShow(false)
                                //consultaCombustiveis()
                                //window.toastr.success('Registro salvo com sucesso!')

                                window.$('#modalEnergiaCombustivel').modal('hide')
                                window.toastr.success('Registro salvo com sucesso!')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
    
                            //}
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaCombustivel', dataPost).then((result) => {

                            //console.log(result.data)
                            //if (result.data.status == 'ok') {
    
                                //setShow(false)
                                //consultaCombustiveis()
                                //window.toastr.success('Registro salvo com sucesso!')

                                window.$('#modalEnergiaCombustivel').modal('hide')
                                window.toastr.success('Registro salvo com sucesso!')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
    
                            //}
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }




    function apagaEnergiaCombustivel() {


        if (energiaCombustivel_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaCombustivel/${energiaCombustivel_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            //consultaCombustiveis()

                            window.$('#modalEnergiaCombustivel').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }



    function limpaDados() {

        //setEnergiaCombustivel_id()

        setCombustivel('')
        setUnidade('')
        setIdentificacao('')
        setConsumoJan('')
        setCustoJan('')
        setConsumoFev('')
        setCustoFev('')
        setConsumoMar('')
        setCustoMar('')
        setConsumoAbr('')
        setCustoAbr('')
        setConsumoMai('')
        setCustoMai('')
        setConsumoJun('')
        setCustoJun('')
        setConsumoJul('')
        setCustoJul('')
        setConsumoAgo('')
        setCustoAgo('')
        setConsumoSet('')
        setCustoSet('')
        setConsumoOut('')
        setCustoOut('')
        setConsumoNov('')
        setCustoNov('')
        setConsumoDez('')
        setCustoDez('')

    }



    useEffect(() => {

        if (combustivel != '') {

            switch (combustivel) {

                case 'Gás Liquefeito de Petróleo (GLP)':
                case 'Lenha (Comercial)':
                    setUnidade('Tonelada')
                    break;


                case 'Gás Natural Seco':
                    setUnidade('Metro cúbico')
                    break;

                
                case 'Óleo Diesel (Comercial)':
                case 'Gasolina Comum (tipo C)':
                case 'Óleo Combustível':
                case 'Etanol Hidratado':
                case 'Gasolina Pura (tipo A)':
                case 'Óleo de Xisto':
                    setUnidade('Litro')
                    break;
    
    
            }

        } else {

            setUnidade('')

        }
        

    }, [combustivel])


    useEffect(() => {

        limpaDados()
        consultaCombustiveisDet()
        consultaCombustiveisDetMensal()

    }, [energiaCombustivel_id])


    return (

        <div>

                <div className="modal fade" id="modalEnergiaCombustivel" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Combustível</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Combustível *
                                                <div class="tooltip">
                                                Selecione o tipo de combustível utilizado (apenas uso estacionário). 
                                                </div>
                                            </span>

                                        </label>
                                    
                                        
                                        <select class="form-control" value={combustivel} onChange={event => setCombustivel(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Etanol Hidratado">Etanol Hidratado</option>
                                            <option value="Gás Natural Seco">Gás Natural Seco</option>
                                            <option value="Gasolina Comum (tipo C)">Gasolina Comum (tipo C)</option>
                                            <option value="Gasolina Pura (tipo A)">Gasolina Pura (tipo A)</option>
                                            <option value="Gás Liquefeito de Petróleo (GLP)">Gás Liquefeito de Petróleo (GLP)</option>
                                            <option value="Óleo Combustível">Óleo Combustível</option>
                                            <option value="Óleo de Xisto">Óleo de Xisto</option>
                                            <option value="Óleo Diesel (Comercial)">Óleo Diesel (Comercial)</option>
                                            <option value="Lenha (Comercial)">Lenha (Comercial)</option>
                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Identificação
                                                <div class="tooltip">
                                                Insira uma descrição para identificar o uso do combustível. Ex.: Óleo Diesel Geradores. 
                                                </div>
                                            </span>

                                        </label>
                                    
                                        <input class="form-control" input="text" value={identificacao} onChange={event => setIdentificacao(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >

                                        <label className="control-label">Unidade</label>
                                        <input class="form-control" input="text" readOnly={true} value={unidade} />
                                            
                                    </div>
                                </div>

                                

                            </div>

                            <div className='row'>

                                <div className="col-md-12" >

                                    <br/>
                                    

                                    <table width="100%" className="table table-bordered table-striped table-hover">

                                        <tbody>
                                            <tr>
                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                    <center>
                                                    Mês
                                                    </center>

                                                </th>
                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                    <center>
                                                    Consumo
                                                    </center>

                                                </th>
                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                    <center>
                                                    Custo (R$)
                                                    </center>

                                                </th>                                               

                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Janeiro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoJan} onChange={event => setConsumoJan(event.target.value)} 
                                                    
                                                    />
                                                    
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoJan} onChange={event => setCustoJan(event.target.value)}
                                                    
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Fevereiro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoFev} onChange={event => setConsumoFev(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoFev} onChange={event => setCustoFev(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Março
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoMar} onChange={event => setConsumoMar(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoMar} onChange={event => setCustoMar(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Abril
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoAbr} onChange={event => setConsumoAbr(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoAbr} onChange={event => setCustoAbr(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Maio
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoMai} onChange={event => setConsumoMai(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoMai} onChange={event => setCustoMai(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Junho
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoJun} onChange={event => setConsumoJun(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoJun} onChange={event => setCustoJun(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Julho
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoJul} onChange={event => setConsumoJul(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoJul} onChange={event => setCustoJul(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Agosto
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoAgo} onChange={event => setConsumoAgo(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoAgo} onChange={event => setCustoAgo(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Setembro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoSet} onChange={event => setConsumoSet(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoSet} onChange={event => setCustoSet(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Outubro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoOut} onChange={event => setConsumoOut(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoOut} onChange={event => setCustoOut(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Novembro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoNov} onChange={event => setConsumoNov(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoNov} onChange={event => setCustoNov(event.target.value)}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <center>
                                                    Dezembro
                                                    </center>
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={consumoDez} onChange={event => setConsumoDez(event.target.value)} 
                                                    
                                                    />
                                                </td>
                                                <td>
                                                    <CurrencyInput type="text" className='form-control' value={custoDez} onChange={event => setCustoDez(event.target.value)}/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>

                            </div>


                            </div>
                            <div className="modal-footer">

                                
                                <button type="button" className="btn btn-danger" onClick={() => apagaEnergiaCombustivel()} style={{ display: energiaCombustivel_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal